import dayjs from "dayjs";
import _ from "lodash";
import { computed, observable } from "mobx";

export class Controller {
  @observable public calendarsDate = null;
  @observable public selectedDates = [];
  @observable public selectedTimeFrom = null;
  @observable public selectedTimeTo = null;
  @observable public rangeFrom = null;

  @observable public showDropDown = false;

  public onSelection = null;
  public props = null;

  constructor(props) {
    this.onSelection = props.onSelection;
    this.props = props;
    this.calendarsDate = props.defaultValue || dayjs();
  }

  @computed get showDateTimePicker() {
    return this.props && this.props.showTimePicker?.show && !this.props.singleSelect;
  }

  public handleSelection = (date) => {
    if (this.props.singleSelect) {
      this.selectedDates = [date];

      this.onSelection(date);
      this.showDropDown = false;
      return;
    }

    // If the range has been selected already, reset it and start over again
    if (this.selectedDates.length === 2) {
      this.selectedDates = [];
    }

    this.selectedDates.push(date);

    // Order dates to be from earlier to latest, no matter how user selects them
    this.selectedDates = _.orderBy(this.selectedDates);

    // Callback with selected days to the main component props
    if (this.selectedDates.length === 2) {
      this.onSelection(this.setDateTime(this.selectedDates));
      this.showDropDown = false;
    }
  };

  public handleTimeSelect = (time, from = true) => {
    if (from) {
      this.selectedTimeFrom = time;
      this.selectedTimeTo = null;
    } else {
      this.selectedTimeTo = time;
    }

    this.onSelection(this.setDateTime(this.selectedDates));
  };

  public setDateTime = (source) => {
    if (this.selectedTimeFrom) {
      source[0] = dayjs(source[0])
        .set("hour", this.selectedTimeFrom.hour())
        .set("minute", this.selectedTimeFrom.minute())
        .set("second", this.selectedTimeFrom.second());
    }

    if (this.selectedTimeTo) {
      source[1] = dayjs(source[1])
        .set("hour", this.selectedTimeTo.hour())
        .set("minute", this.selectedTimeTo.minute())
        .set("second", this.selectedTimeTo.second());
    }

    // If there are no selected times, make sure the time is set to start and end of day
    if (!this.selectedTimeFrom && !this.selectedTimeTo) {
      source[0] = dayjs(source[0]).startOf("day");
      source[1] = dayjs(source[1]).endOf("day");
    }

    // Only convert to iso string if the prop is passed, otherwise return moment objects
    if (this.props.showTimePicker?.toISOString) {
      source[0] = dayjs(source[0]).toISOString();
      source[1] = dayjs(source[1]).toISOString();
    }

    return source;
  };
}
